module.exports = __webpack_public_path__ + "static/nutrition-7c0e4d00438f65d79127091d4f8a35e3.svg";